/**
 * The web app shows sign-in the moment web.apiboo.com opens (owner
 * 12.10.2026: "desktop stays unchanged, the web version has to show the login
 * as soon as web.apiboo.com is accessed"). The web app has no device storage:
 * every board and document lives on the server, so an unsigned visitor could
 * only click around an empty shell and lose the first thing they typed.
 *
 *   'app'     render the app (desktop always; web once signed in)
 *   'loading' web, the session cookie is still being refreshed — no flash of
 *             the shell or of the sign-in page
 *   'signin'  web, no session — the sign-in page, nothing else
 */
import { isWebApp } from './target';

export function webGateState({ isInitialized, isAuthenticated }) {
  if (!isWebApp()) return 'app';
  if (!isInitialized) return 'loading';
  return isAuthenticated ? 'app' : 'signin';
}
